export const VIEW_OPTIONS = [
  { id: 'display', label: 'View', options: ['SHOW IN SEQUENCE', 'SHOW ALL'] },
  { id: 'mode', label: 'Switch to Auto / Manual', options: ['AUTO', 'MANUAL'] },
];

const createFrameRange = (end) => Array.from({ length: end }, (_, index) => index + 1);

export const YOGA_SERIES = [
  {
    id: 'sūryanamaskāra_a',
    sequenceFrames: [...createFrameRange(11), 13, 14],
    previewDirectory: 'preview-optimized',
    previewFrames: [1, 2, 3, 5, 6, 7, 8, 9, 10, 11],
    poseNotes: {
      4: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      10: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
    },
  },
  { 
    id: 'sūryanamaskāra_b',
    sequenceFrames: createFrameRange(19),
    previewDirectory: 'preview-optimized',
    previewFrames: [1, 2, 3, 4, 7, 8, 9, 10, 11],
    poseNotes: {
      8: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      12: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
    },
  },
  {
    id: 'standing_sequence',
    sequenceFrames: createFrameRange(47),
    showAllDirectory: 'show-all',
    showAllExtension: 'jpg',
    previewFrames: [1, 2, 3, 5, 6, 7],
    poseNotes: {
      3: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      4: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      5: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      6: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      7: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      8: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      16: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      17: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      18: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      20: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      21: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      22: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      24: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      25: { text: 'Right leg in front', backgroundColor: 'black', textColor: '#fff' },
      26: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },
      27: { text: 'Left leg in front', backgroundColor: 'white', textColor: '#000' },

    },
  },
  {
    id: 'seated_sequence',
    sequenceFrames: [],
    previewFrames: [1, 4, 8],
    mainImage: 'main.png',
  },
  { id: 'finishing_sequence', sequenceFrames: [], previewFrames: [] },
];

export const DEFAULT_SETTINGS = {
  mode: 'MANUAL',
  display: 'SHOW IN SEQUENCE',
};

const publicUrl = process.env.PUBLIC_URL || '';

export const getImagePath = (path) => `${publicUrl}/images/${path}`;

export const getLoadingPreviewPaths = () => YOGA_SERIES
  .filter((series) => series.previewFrames.length > 0)
  .flatMap((series) => {
    const middleIndex = Math.floor(series.previewFrames.length / 2);
    const selectedFrames = [
      series.previewFrames[0],
      series.previewFrames[middleIndex],
      series.previewFrames[series.previewFrames.length - 1],
    ];

    return [...new Set(selectedFrames)].map((frame) => (
      getImagePath(`${series.id}/loading/frame-${String(frame).padStart(2, '0')}.jpg`)
    ));
  });

const imageExists = (src) => new Promise((resolve) => {
  const image = new Image();
  image.onload = () => resolve(true);
  image.onerror = () => resolve(false);
  image.src = src;
});

export const preloadLoadingPreviews = () => Promise.all(
  getLoadingPreviewPaths().map(imageExists),
);

export const loadYogaSeries = async () => Promise.all(
  YOGA_SERIES.map(async (series) => {
    const mainImage = getImagePath(
      `${series.id}/preview/${series.mainImage || 'main-optimized.jpg'}`,
    );
    await imageExists(mainImage);

    return {
      ...series,
      hasSequence: series.sequenceFrames.length > 0,
      name: series.id.replace(/_/g, ' '),
      src: mainImage,
    };
  }),
);
